<template>
  <div>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <form method="#" action="#" @submit.prevent="validateBeforeSubmit()">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <img src="https://cdn.shopify.com/s/files/1/2198/4059/files/524996_Logo_Tagline-Blue_0904191_300x300.png?v=1572905596" alt="Kegelbell" style="max-width: 300px;">
                  <h2>Thank you for your purchase!<br><small>Welcome to the Kegelbell family</small></h2>
                </div>
              </div>
              <div class="col-md-8 col-md-offset-2">
                  <div class="card card-plain">
                    <div class="footer text-center">
                      <button type="button" v-if="!loading" @click.prevent="gotoInstructions()" class="btn btn-fill btn-danger btn-wd">View Instruction Guides</button>
                      <button type="button" v-if="loading" class="btn btn-wd btn-danger" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        View Instruction Guides
                      </button>
                    </div>
                  </div>
              </div>
              </form>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2019 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
// import { stripeKey, stripeOptions } from './stripeConfig.json'
import { Card, createToken } from 'vue-stripe-elements-plus'
import { uuid } from 'vue-uuid'
import swal from 'sweetalert2'
import {mapFields} from 'vee-validate'
import qs from 'qs'
import db from '@/components/firebase/init'
import firebase from 'firebase'
import 'firebase/functions'

export default {
  data () {
    return {
      myvariable: 4,
      modelValidations: {
        email: {
          email: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        country: {
          required: true
        }
      },
      loading: false,
      step: 1,
      complete: false,
      model: {
        firstName: '',
        lastName: '',
        email: '',
        birthday: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        goals: {
          healthyVagina: false,
          postpartumRecovery: false,
          bladderLeakage: false,
          organProlapse: false,
          sexualHealth: false,
          vaginalRejuvenation: false
        },
        sendShowerHolder: true,
        optIn: true
      },
      code: false,
      codeData: false
    }
  },

  components: { Card },

  methods: {
    init () {
      this.loading = true
      this.checkCode()
    },
    gotoInstructions () {
      location.replace('https://www.kegelbell.com/pages/instructions')
    },
    checkCode () {
      let checkCode = firebase.functions().httpsCallable('checkCode')
      checkCode({ code: this.code, doNotValidate: true })
      .then(result => {
        console.log(result)
        if (!result.data.valid) {
          swal.fire({
            title: 'Not Authentic!',
            text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          .then(() => {
            this.$router.replace('/authenticate?code=' + this.model.code)
          })
        } else if (result.data.type === 'external') {
          // tbd
          console.log('external')
        } else { // existing primary code
          // tbd
          console.log('primary')
          this.codeData = result.data
          console.log(this.codeData)
        }
        this.loading = false
      })
      .catch(err => {
        console.error(err.message)
        swal.fire({
          title: 'Not Authentic!',
          text: 'Sorry! You have reached this page without a valid code. You will be redirected.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        .then(() => {
          this.$router.replace('/authenticate?code=' + this.model.code)
        })
        this.loading = false
      })
    },
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    async submit () {
      try {
        let data = {
          contactDetails: this.model,
          code: this.code
        }
        let registerAuthCode = firebase.functions().httpsCallable('registerAuthCode')
        registerAuthCode(data)
        let result = await registerAuthCode(data)
        if (!result.data.success) {
          this.$router.replace('/authenticate?code=' + this.code)
        }
        console.log(result)
        let msg = ''
        if (!this.model.sendShowerHolder) msg = 'You will now be sent to the Kegelbell instructions video.'
        else msg = 'We will send your Kegelbell Shower Holder ASAP! You will now be sent to the Kegelbell instructions video.'
        swal.fire({
          title: `Thank you!`,
          text: msg,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        })
        .then(() => {
          console.log('sending to kegelbelll.com')
          location.replace('https://www.kegelbell.com/pages/instructions')
        })
        this.loading = false
      } catch (err) {
        swal.fire({
          title: 'Error',
          text: 'Sorry! There was an error with your submission. Please contact us at orders@kegelbell.com and let us know.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        .then(() => {
          location.replace('https://www.kegelbell.com/pages/instructions')
        })
      }
    },
    signup () {
      console.log('signing up')
      let signup = firebase.functions().httpsCallable('signup')
      signup(this.model)
      .then(result => {
        console.log(result)
      })
      .catch(err => {
        console.error(err.message)
      })
    },
    beforeDestroy () {
      this.closeMenu()
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validateBeforeSubmit () {
      this.loading = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.submit()
          // this.signup()
        } else {
          this.loading = false
        }
      })
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      // if (this.$route.params.code) this.code = this.$route.params.code
      // else if (this.$route.query.code) this.code = this.$route.query.code
      // if (!this.code) this.$router.replace('/authenticate')
      // this.init()
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/RegisterKegelbellBasic.vue